import React, {Component, PureComponent} from 'react'
import PageHeaderWrapper from '../../components/PageHeaderWrapper/index'
import {TableComp} from 'sz-react-utils'
// import GetAllFormFields from '../../../components/_utils/formUtils'
import {Button, Card, Form,Row,Col, Tooltip, DatePicker, Select, Drawer, notification} from 'antd';
import {FormUtils as GetAllFormFields} from 'sz-react-utils'
import _ from 'lodash'
import Request, { API_URL } from '../../request'
import {connect} from 'react-redux'
import StaffLeaveAction from '../../components/_utils/staffLeaveAction.js'
import moment from 'moment'
import { RightsWrapper } from '../../components/_utils/utils'
import UpdateAppraisal from '../../components/_utils/updateAppraisal';



const {MonthPicker} = DatePicker
const Option = Select.Option;




@Form.create()
class AddAppraisalRequest extends Component {
    state = {
        allUsers:[],
        recordId:''
    }

    componentDidMount() {
        let {users, userData} = this.props;
        this.setState({allUsers:users})
    }

    handleSubmit = (e) =>{
        let {form, dispatch, handleSubmit} = this.props
        e.preventDefault();
        form.validateFieldsAndScroll(async(err,valData)=>{
            let values = _.clone(valData)
            handleSubmit(values)
        })
    }

    render() {
        let {allUsers} = this.state
        let {form:{getFieldDecorator, getFieldValue}} = this.props
        const inputTypes = {
            fields:[
                {
                    label:'Appraisal Type',
                    key:'appraisalType',
                    type:'select',
                    options:["Performance Appraisal", "Annual Appraisal"],
                    required:true,
                    onChange:v=>{
                        this.props.form.setFieldsValue({appraisalType:v})
                    }
                },
                {
                    label:'Expected Appraisal Amount',
                    key:'expectedAppraisal',
                    type:'number',
                    required:true
                }
            ]
        }
        return (
            <Card>
                <Form onSubmit={this.handleSubmit}>
                    <GetAllFormFields apiurl={API_URL} inputSchema={inputTypes} getFieldDecorator={getFieldDecorator} />
                    <Row style={{marginTop:'20px'}}>
                            <Col span={8}/>
                            <Col span={8}>
                                <Button
                                    type="primary"
                                    htmlType="submit"
                                    style={{marginBottom: 10}}
                                    loading={this.props.loading}>
                                    Save
                                </Button>
                            </Col>
                            <Col span={8}/>
                        </Row>
                </Form>
            </Card>
        )
    }
}


@Form.create()
class AppraisalRequests extends PureComponent {
    state = {
        studentId: '',
        count: 0,
        defaultPageSize: 20,
        month:moment(),
        activityArr: [],
        oldLeaves:[],
        record:{},
        allUsers:[],
        userId:null,
        showLeaveActionForm:false,
        showAppraisalAddForm:false,
        showAppraisalEditForm:false,
    }



    refreshFxn = () => {
        this.setState({refreshChild: !this.state.refreshChild})
    }

    constructor(props) {
        super(props)
        this.table = React.createRef()
    }

    handleStaffLeaveApplication = (record) =>{
        this.setState({showLeaveActionForm:true, record:record})
    }

    handleStaffLeaveApplicationClose = () =>{
        this.setState({showLeaveActionForm:false, record:{}})
        this.table.current.reload()
    }

    handleAdd=()=>{
        this.setState({showAppraisalAddForm:true})
    }

    handleClose = () =>{
        this.setState({showLeaveAddForm:false})
        this.reload()
    }

    onClose = () =>{
        this.setState({showAppraisalAddForm:false, record:{}, viewDetailRecord:{}, showAppraisalEditForm:false})
        this.reload()
    }

    apiRequest = params =>{
        return new Promise(async(resolve)=>{
            if(this.state.userId) {
                params.userId = this.state.userId
            }
            let response = await Request.getUserAppraisalRequest(params);
            this.setState({count:response.total})
            resolve(response)
        })
    }

    getCurrentUser() {
        let response = JSON.parse(localStorage.getItem('user'));
        return response
    }

    handleMonthChange = (month,dateString) =>{
        this.setState({month:moment(month)}, ()=>{
            this.reload()
        })
    }


    handleAppraisalEdit = (data) =>{
        this.setState({record:data, showAppraisalEditForm:true})
    }

    async componentDidMount() {
        let currentUser = await this.getCurrentUser()
        let params = {
            sortField:'_id',
            sortOrder:'ascend',
            results: 200,
            active:true,
            userType:{$ne : "Student"},
            userBranch:currentUser.userBranch
        };

        let response = await Request.loadUser({...params, regExFilters: ['name']})
        let userArray = [];
        response.data.map((user, index)=>{
            userArray.push({
                _id: user._id,
                display: user.name
            })
        })
        this.setState({allUsers:userArray})
    }

    reload = () => {    
        this.table.current.reload();
    };

    render() {
        const {defaultPageSize, showLeaveActionForm, count, record, allUsers, showAppraisalAddForm, showAppraisalEditForm} = this.state
        let columns = [
            {
                title:'Requested Appraisal Type',
                key:'appraisalType'
            },
            {
                title:'Expected Appraisal Amount',
                key:'expectedAppraisal'
            },
            {
                title:'Final Appraisal Amount',
                key:'finalAppraisal'
            },
            {
                title:'Current Status',
                key:'activeStatus'
            },
            {
                title:'Status',
                key:'status'
            }
        ]
        // const columns = [
        //     {
        //         title:'Employee Name',
        //         key:'userId.name',
        //     },
        //     {
        //         title: 'Last Appraisal Date',
        //         key: 'appraisalDate',
        //         render:(text,record)=>(
        //             <div>{record && moment(record.appraisalDate).format('DD-MMMM-YYYY')}</div>
        //         )
        //     },
        //     {
        //         title:'Appraisal Type',
        //         key:'appraisalType'
        //     },
        //     {
        //         title:'Next Appraisal Date',
        //         key:'nextAppraisalDate',
        //         render:(text,record) =>(
        //             <div>{record.nextAppraisalDate && moment(record.nextAppraisalDate).format('DD-MMMM-YYYY')}</div>
        //         )
        //     },
            
        //     {
        //         title: 'Date of Joining',
        //         key: 'dateOfJoining',
        //         render:(text,record)=>(
        //             <div>{record && moment(record.dateOfJoining).format('DD-MMMM-YYYY')}</div>
        //         )
        //     },
        //     {
        //         title:'Salary',
        //         key:'staffSalary',
        //         render:(text,record)=>(
        //             <div>{record && record.staffSalary}</div>
        //         )
        //     },
        //     {
        //         title:'Approved By',
        //         key:'approvedBy'
        //     },
        //     {
        //         title:'Action',
        //         key:'operation',
        //         dataindex: "operation",
        //         render: (text, record) => (
        //             <RightsWrapper myRight={'StaffLeaves.edit'}>
        //             <React.Fragment>
        //             <Tooltip title="Edit Appraisal">
        //               <Button
        //                 size={"small"}
        //                 shape="circle"
        //                 onClick={() => this.handleAppraisalEdit(record)}
        //                 icon="edit"
        //               />
        //             </Tooltip>&nbsp;
        //           </React.Fragment>
        //           </RightsWrapper>
        //         ),
        //     }
        // ]


    return (
        <PageHeaderWrapper title={`Appraisal Request:- ${count}` }>
            {
                showLeaveActionForm?
                <StaffLeaveAction record={record} onClose={this.handleStaffLeaveApplicationClose} />
                :null
            }
            {
                showAppraisalEditForm?
                <UpdateAppraisal allUsers={allUsers} record={record} onClose={this.onClose} />
                :null
            }
            <Card bordered={true}>
                <Row>   
                    <Col span={2}>
                        <div style={{textAlign: 'right', marginTop: '15px'}}>
                            <Button onClick={()=>this.handleAdd()}>Add Appraisal Request</Button>
                        </div>
                    </Col>
                </Row>
            </Card>
            <Card bordered={true} >
                <TableComp
                    ref={this.table}
                    columns={columns}
                    apiRequest={this.apiRequest}
                    pagination={{
                        showSizeChanger: true,
                        defaultPageSize: defaultPageSize,
                        pageSizeOptions: ['10', '20', '50', '100', '1000']
                    }}
                />
            </Card>

            <Drawer
                    title="Request For Appraisal"
                    placement="right"
                    closable={true}
                    onClose={this.onClose}
                    visible={showAppraisalAddForm}
                    width={700}>
                    <div>
                        <AddAppraisalRequest
                            loading={this.props.loading}
                            users={allUsers}
                            userData={record}
                            handleSubmit={async(values)=>{
                                let response = await Request.addAppraisalRequest(values)
                                if(response.success) {
                                    notification.success({
                                        message:response.message
                                    })
                                }else {
                                    notification.error({
                                        message:response.message
                                    })
                                }
                                this.onClose()
                            }}
                        />
                    </div>
                </Drawer>
        </PageHeaderWrapper>
        )
    }
}

const mapStateToProps = ({global, router}) => ({
    loading: global.buttonLoading,
    categories: global.categories,
    search: router.location.search,
    pathname: router.location.pathname
})
const mapDispatchToProps = dispatch => {
    return {
        dispatch
    }
}
export default connect(
    mapStateToProps,
    mapDispatchToProps
)(AppraisalRequests)
